const renderPagination = function (totalPages, currentPage) {
  const paginationContainer = document.querySelector(".js-pagination");
  const maxVisibleButtons = 5;

  if (totalPages <= 1) {
    paginationContainer.innerHTML = "";
    return;
  }

  let paginationHTML = "";
  const startPage = Math.max(1, currentPage - Math.floor(maxVisibleButtons / 2));
  const endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);

  // Previous Button
  if (currentPage > 1) {
    paginationHTML += `<button class="js-page-button step-button" id="${currentPage - 2}">‹</button>`;
  }

  // Page Numbers
  if (startPage > 1) {
    paginationHTML += `<button class="page-button js-page-button dim" id="0">1</button>`;
    if (startPage > 2) {
      paginationHTML += `<form method="get" class="page-input-form js-page-input">
        <input type="number" name="page" min="1" max="${totalPages}" placeholder="..." aria-label="Page input" class="pagination-dots">
      </form>`;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    paginationHTML += `<button class="page-button js-page-button ${i === currentPage ? "active" : ""}" id="${
      i - 1
    }">${i}</button>`;
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      paginationHTML += `<form method="get" class="page-input-form js-page-input">
        <input type="number" name="page" min="1" max="${totalPages}" placeholder="..." aria-label="Page input" class="pagination-dots">
      </form>`;
    }
    paginationHTML += `<button class="page-button js-page-button dim" id="${totalPages - 1}">${totalPages}</button>`;
  }

  if (currentPage < totalPages) {
    paginationHTML += `<button class="js-page-button step-button" id="${currentPage}">›</button>`;
  }

  paginationContainer.innerHTML = paginationHTML;
};

window.renderPagination = renderPagination;

// drawer code

const openDrawerEl = document.getElementById("openDrawer");
const overlayElem = document.querySelector(".collection-drawer__overlay");
openDrawerEl.addEventListener("click", () => {
  document.getElementById("collection-drawer").classList.add("open");
  openDrawerEl.classList.add("is-open");
  overlayElem.classList.add("is-open");
  document.body.classList.add("remove-scrolling");
});

document.getElementById("closeDrawer").addEventListener("click", () => {
  document.getElementById("collection-drawer").classList.remove("open");
  openDrawerEl.classList.remove("is-open");
  overlayElem.classList.remove("is-open");
  document.body.classList.remove("remove-scrolling");
});

if (overlayElem) {
  overlayElem.addEventListener("click", () => {
    document.getElementById("collection-drawer").classList.remove("open");
    openDrawerEl.classList.remove("is-open");
    overlayElem.classList.remove("is-open");
    document.body.classList.remove("remove-scrolling");
  });
}

// facets view all logic

const viewAllFilters = () => {
  const viewAllButtons = document.querySelectorAll(".view-all");

  viewAllButtons.forEach((button) => {
    const listItems = button
      .closest(".multi-select-container")
      .querySelectorAll(".multi-select-dropdown .multi-select-option");
    let isExpanded = false;

    button.addEventListener("click", () => {
      if (isExpanded) {
        // Hide all but the first three items
        listItems.forEach((item, index) => {
          if (index >= 3) {
            item.style.display = "none";
          }
        });
        button.textContent = "View All";
      } else {
        // Show all items
        listItems.forEach((item) => {
          item.style.display = "flex";
        });
        button.textContent = "View Less";
      }
      isExpanded = !isExpanded;
    });
  });
};

window.viewAllFilters = viewAllFilters;
